export default __webpack_public_path__ + "static/media/copy.1dff4481.svg";